import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {VisualRecipientModel} from '../../../../models/api/visualRecipientModel';
import {AppState} from '../../../../store/appState';
import {
  makeGetRecipientRelation,
  makeGetVisualRecipientEmail,
} from '../../../../store/stateless/recipientSelectors';
import {RecipientToken} from './recipientToken';

/*
 * Props.
 */

interface RecipientTokenContainerProps {
  recipient: VisualRecipientModel;
  sendAddressDomain?: string;
}

/*
 * Selectors.
 */

function getSendAddressDomain(_state: AppState, props: RecipientTokenContainerProps) {
  return props.sendAddressDomain;
}

function getRecipient(_state: AppState, props: RecipientTokenContainerProps) {
  return props.recipient;
}

const getRecipientEmail = makeGetVisualRecipientEmail(getRecipient);

const getRecipientRelation = makeGetRecipientRelation(getSendAddressDomain, getRecipientEmail);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<RecipientTokenContainerProps>()(() => ({
  recipientRelation: getRecipientRelation,
}));

export const RecipientTokenContainer = connect(mapStateToProps)(RecipientToken);
